import orderStatuses from '@/util/orderStatuses'
import { format } from 'date-fns'
import Pagination from '@/util/pagination'

export default function () {
  return {
    orderStatuses,
    format,
    createdAtBeforePicker: false,
    createdAtAfterPicker: false,
    pagination: new Pagination(),
    filters: {
      status: '',
      'user.email': '',
      'createdAt[before]': '',
      'createdAt[after]': '',
      'discountCoupons.code': '',
    },
    orders: [],
  }
}
